<template>
  <DetailTemplate
    :customClass="'leave-detail detail-page'"
    v-if="getPermission('Leave:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-0">
          <template v-if="pageLoading">
            <v-skeleton-loader
              class="custom-skeleton height-40px custom-skeleton-full-width"
              width="600"
              type="text"
            >
            </v-skeleton-loader>
            <v-skeleton-loader
              class="custom-skeleton height-30px my-auto mx-2 custom-skeleton-full-width"
              width="100"
              type="text"
            >
            </v-skeleton-loader>
          </template>
          <template v-else>
            <v-tooltip top content-class="custom-top-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-bind="attrs"
                  class="custom-status ml-4 font-weight-600 custom-grey-border text-uppercase justify-center d-inline"
                  v-on="on"
                  label
                  color="blue"
                  text-color="white"
                >
                  {{ leaveDetail?.barcode }}
                </v-chip>
              </template>
              <span>Leave</span>
            </v-tooltip>
            <v-chip
              v-bind="attrs"
              v-on="on"
              label
              outlined
              color="blue"
              class="ml-3"
            >
              {{ leaveDetail?.leave_types?.toUpperCase() }}
            </v-chip>
          </template>
        </div>
        <div class="px-2 py-5 text-center">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="image"
          >
          </v-skeleton-loader>
          <v-skeleton-loader
            v-if="pageLoading"
            class="custom-skeleton height-40px custom-skeleton-full-width"
            width="600"
            type="text"
          >
          </v-skeleton-loader>
          <template v-else>
            <v-img
              :lazy-src="$defaultProfileImage"
              :src="leaveDetail.profile_logo"
              aspect-ratio="1"
              max-height="150"
              max-width="150"
              class="margin-auto custom-grey-border custom-border-radius-50"
              transition="fade-transition"
            >
            </v-img>
            <h1
              class="form-title custom-nowrap-ellipsis text-capitalize mt-4 mb-0"
            >
              {{ leaveDetail?.full_name }}
            </h1>
          </template>
        </div>
        <div class="">
          <table class="width-100">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-19 color-custom-blue py-1"
              >
                Cleaner Information
              </th>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Cleaner #
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-uppercase">
                <template>
                  <v-chip
                    small
                    outlined
                    label
                    color="blue"
                    @click="goToEngDetail(leaveDetail?.staffde?.id)"
                  >
                    {{ leaveDetail?.staffde?.barcode }}</v-chip
                  >
                </template>
                <template v-if="false"
                  ><em class="text--secondary font-weight-500"
                    >No Leave #</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Display Name
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-uppercase">
                <template>
                  {{ leaveDetail.user_display_name }}
                  <!-- <v-chip small outlined label color="blue">{{leaveDetail.user_data.user_name}}</v-chip> -->
                </template>
                <template v-if="false"
                  ><em class="text--secondary font-weight-500"
                    >No Leave #</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Designation
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-titlecase">
                <template v-if="leaveDetail.user_designation">
                  <v-chip small outlined label color="blue">
                    {{ leaveDetail.user_designation }}
                  </v-chip>
                </template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Designation</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Email
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-lowercase">
                <template v-if="leaveDetail.user_email">
                  {{ leaveDetail.user_email }}
                </template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Email</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Phone
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-lowercase">
                <template v-if="leaveDetail.user_phone">
                  {{ leaveDetail.user_phone }}
                </template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Phone</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Leave Reason
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-lowercase">
                <template v-if="leaveDetail.reason">
                  <read-more class="custom-read-more font-weight-600 font-size-18  " style="display: block;"
                    more-str="read more" :text="leaveDetail.reason || '<em>No Reason</em>'" link="#"
                    less-str="read less" :max-chars="25" />
                </template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No leave reason</em
                  ></template
                >
              </td>
            </tr>
            <tr v-if="false">
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Probation Period
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-lowercase">
                <template v-if="leaveDetail.probation_period">
                  <v-chip small outlined label color="blue">
                    {{ leaveDetail.probation_period }}
                  </v-chip>
                </template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Probation Period</em
                  ></template
                >
              </td>
            </tr>
          </table>
          <table class="width-100 mt-5" v-if="false">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 font-size-19 color-custom-blue py-1"
              >
                Emergency Details
              </th>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Contact leave
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-lowercase">
                <template v-if="leaveDetail.user_data.full_name">
                  {{ leaveDetail.user_data.full_name }}
                </template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Contact leave</em
                  ></template
                >
              </td>
            </tr>
            <tr>
              <td
                class="py-1 font-size-18 text-capitalize font-weight-700"
                width="150"
              >
                Phone Number
              </td>
              <td class="py-1 font-size-18 font-weight-600 text-lowercase">
                <template v-if="leaveDetail.user_data.phone_number">
                  {{ leaveDetail.user_data.phone_number }}
                </template>
                <template v-else
                  ><em class="text--secondary font-weight-500"
                    >No Phone Number</em
                  ></template
                >
              </td>
            </tr>
          </table>
        </div>
      </v-card>
    </template>
    <template v-slot:header-title>
      <div class="d-flex">
        <template v-if="pageLoading">
          <v-skeleton-loader
            class="custom-skeleton height-40px custom-skeleton-full-width"
            width="600"
            type="text"
          >
          </v-skeleton-loader>
          <!-- <v-skeleton-loader
            class="custom-skeleton height-30px my-auto mx-2 custom-skeleton-full-width"
            width="100"
            type="text"
          >
          </v-skeleton-loader> -->
        </template>
        <template v-else>
          <!-- <h1 class="form-title custom-nowrap-ellipsis text-capitalize mb-0">
            {{ leaveTitle }}   
          </h1> -->
          <!-- <CustomStatus
            :status="leaveDetail.status"
            endpoint="leave/status"
          ></CustomStatus> -->
        </template>
      </div>
    </template>
    <template v-slot:header-action>
      <!-- <v-btn
        :disabled="!formValid || formLoading || pageLoading"
        :loading="formLoading"
        class="mx-2 custom-bold-button white--text"
        color="cyan"
        v-on:click="updateMoreAction('edit')"
      >
        Edit <v-icon small>mdi-pencil</v-icon>
      </v-btn> -->
      <v-btn
        v-if="false"
        depressed
        :disabled="!formValid || formLoading || pageLoading"
        :loading="formLoading"
        class="mx-2 custom-bold-button white--text"
        color="red lighted-1"
        v-on:click="updateMoreAction('delete')"
      >
        Delete <v-icon small>mdi-delete</v-icon>
      </v-btn>
      <v-menu
        transition="slide-y-transition"
        bottom
        content-class="custom-menu-list"
        offset-y
        v-if="leaveDetail.status < 2"
      >
        <template v-slot:activator="{ on, attrs }">
          <!-- <v-btn depressed :disabled="!formValid || formLoading || pageLoading" :loading="formLoading"
            class="mx-2 custom-bold-button white--text" color="cyan" v-bind="attrs" v-on="on">
            More... <v-icon right>mdi-chevron-down</v-icon>
          </v-btn> -->
        </template>
        <v-list>
          <template v-for="(more, index) in moreActions">
            <v-list-item
              link
              v-on:click="updateMoreAction(more.action)"
              :key="index"
              :disabled="more.disabled"
            >
              <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-500 font-size-14">{{
                more.title
              }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      <v-btn
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <div class="d-flex justify-space-between py-3 mx-auto w-100"></div>
      <v-tabs
        v-model="leaveTab"
        background-color="transparent"
        color="cyan"
        class="custom-tab-transparent"
      >
        <template v-for="(tab, index) in tabs">
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            :key="index"
            :href="'#' + tab.key"
            :disabled="tab.disabled"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg
                :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
              />
              <!--end::Svg Icon-->
            </span>
            {{ tab.title }}
          </v-tab>
        </template>
      </v-tabs>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll"
        style="max-height: 89vh position: relative"
      >
        <v-tabs-items v-model="leaveTab">
          <v-tab-item v-if="getPermission('Leave:view')" :value="'leave'">
            <v-row>
              <v-col md="6" v-if="false">
                <table width="100%">
                  <template v-if="leaveDetail.engineer">
                    <tr>
                      <td width="300" class="pb-2 font-size-18 text-capitalize">
                        Cleaner Display Name
                      </td>
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-capitalize"
                      >
                        {{ leaveDetail.engineer.display_name }}
                      </td>
                    </tr>
                    <tr>
                      <td width="300" class="pb-2 font-size-18 text-capitalize">
                        Cleaner Email
                      </td>
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-lowercase"
                      >
                        {{ leaveDetail.engineer.user_email }}
                      </td>
                    </tr>
                    <tr>
                      <td width="300" class="pb-2 font-size-18 text-capitalize">
                        Cleaner Phone Number
                      </td>
                      <td
                        class="pb-2 font-size-18 font-weight-600 text-capitalize"
                      >
                        {{ leaveDetail.engineer.phone_number }}
                      </td>
                    </tr>
                  </template>
                  <!-- <tr>
                    <td width="300" class="pb-2 font-size-18 text-capitalize">
                      Leave Type
                    </td>
                    <td
                      class="pb-2 font-size-18 font-weight-600 text-capitalize"
                    >
                      <template v-if="leaveDetail.leave_type">{{
                        leaveDetail.leave_type
                      }}</template>
                      <template v-else
                        ><em class="text--secondary"
                          >No Leave Type</em
                        ></template
                      >
                    </td>
                  </tr> -->
                  <tr v-if="false">
                    <td width="300" class="pb-2 font-size-18 text-capitalize">
                      Team Email ID
                    </td>
                    <td
                      class="pb-2 font-size-18 font-weight-600 text-lowercase"
                    >
                      <template v-if="leaveDetail.team_email_id">{{
                        leaveDetail.team_email_id
                      }}</template>
                      <template v-else
                        ><em class="text--secondary"
                          >No Team Email ID
                        </em></template
                      >
                    </td>
                  </tr>
                </table>
              </v-col>
              <v-col md="6" v-if="false">
                <table width="100%">
                  <tr>
                    <td width="200" class="pb-2 font-size-18 text-capitalize">
                      Leave #
                    </td>
                    <td
                      class="pb-2 font-size-18 font-weight-600 text-capitalize"
                    >
                      {{ leaveDetail.barcode }}
                    </td>
                  </tr>
                  <tr>
                    <td width="200" class="pb-2 font-size-18 text-capitalize">
                      Leave Duration
                    </td>
                    <td
                      class="pb-2 font-size-18 font-weight-600 text-capitalize"
                    >
                      <template v-if="leaveDetail.leave_duration">{{
                        lodash.toUpper(leaveDetail.leave_duration)
                      }}</template>
                      <template v-else
                        ><em class="text--secondary"
                          >No Leave Duration</em
                        ></template
                      >
                    </td>
                  </tr>
                  <tr>
                    <td width="200" class="pb-2 font-size-18 text-capitalize">
                      Start Date
                    </td>
                    <td
                      class="pb-2 font-size-18 font-weight-600 text-capitalize"
                    >
                      <template v-if="leaveDetail.leave_start_date">{{
                        formatDate(leaveDetail.leave_start_date)
                      }}</template>
                      <template v-else
                        ><em class="text--secondary"
                          >No Start Date</em
                        ></template
                      >&nbsp;
                      <template
                        v-if="
                          leaveDetail.leave_duration == 'half-day' &&
                          leaveDetail.leave_start_time
                        "
                        >{{
                          formatTime(leaveDetail.leave_start_time)
                        }}</template
                      >
                    </td>
                  </tr>
                  <tr>
                    <td width="200" class="pb-2 font-size-18 text-capitalize">
                      End Date
                    </td>
                    <td
                      class="pb-2 font-size-18 font-weight-600 text-capitalize"
                    >
                      <template v-if="leaveDetail.leave_end_date">{{
                        formatDate(leaveDetail.leave_end_date)
                      }}</template>
                      <template v-else
                        ><em class="text--secondary">No End Date</em></template
                      >&nbsp;
                      <template
                        v-if="
                          leaveDetail.leave_duration == 'half-day' &&
                          leaveDetail.leave_end_time
                        "
                        >{{ formatTime(leaveDetail.leave_end_time) }}</template
                      >
                    </td>
                  </tr>
                </table>
              </v-col>
              <v-col md="12" lg="12">
                <v-card
                  flat
                  class="custom-grey-border remove-border-radius mb-4 h-100"
                >
                  <v-card-title class="headline grey lighten-4">
                    <span
                      class="font-weight-700 custom-headline color-custom-blue font-size-16"
                    >
                      All Leaves</span
                    >
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <div align="right">
                      <v-btn
                        @click="deleteConfirmDialog = true"
                        class="p-3 m-3"
                        color="red lighten-1"
                        v-if="selectedRows.length > 0"
                      >
                        <span
                          class="hidden-sm-and-down font-size-18 white--text"
                          >Delete Leave(s)</span
                        >
                      </v-btn>
                    </div>

                    <ListingTable :columnCount="5" :rowDate="engineerLeave">
                      <template v-slot:thead>
                        <!-- <template v-slot:default> -->
                        <thead class="custom-border-bottom custom-border-top">
                          <tr>
                            <th width="10" class="simple-table-th">
                              <v-checkbox
                                v-model="selectedAll"
                                class="hide-margin"
                                color="cyan"
                                dense
                                hide-details
                              />
                            </th>
                            <th width="150" class="simple-table-th">Date</th>
                            <th width="150" class="simple-table-th">Day</th>
                            <th width="150" class="simple-table-th">
                              Created At
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-if="engineerLeave.length > 0">
                            <tr
                              v-for="(leave, index) in engineerLeave"
                              :key="index"
                              :class="{
                                'custom-border-top': index == 0,
                                'orange_lighten-5': index % 2 == 0,
                              }"
                            >
                              <td>
                                <v-checkbox
                                  v-model="selectedRows"
                                  color="cyan"
                                  dense
                                  hide-details
                                  :value="leave.id"
                                />
                              </td>
                              <td class="simple-table-td">
                                <template v-if="leave?.leave_date">
                                  <span class="font-weight-500">{{
                                    formatDate(leave?.leave_date)
                                  }}</span>
                                </template>
                                <em v-else class="text-muted"> no date</em>
                              </td>
                              <td class="simple-table-td">
                                <template v-if="leave?.leave_date_weak">
                                  <span class="font-weight-500">{{
                                    leave?.leave_date_weak
                                  }}</span>
                                </template>
                                <em v-else class="text-muted"> no week</em>
                              </td>
                              <td class="simple-table-td">
                                <template v-if="leave?.added_at">
                                  <span class="font-weight-500">{{
                                    formatDate(leave.added_at)
                                  }}</span>
                                </template>
                                <em v-else class="text-muted"> no date</em>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <template v-if="pageLoading">
                              <tr v-for="row in 5" :key="row">
                                <td>
                                  <v-skeleton-loader
                                    type="text"
                                    class="custom-skeleton table-rows-text"
                                  ></v-skeleton-loader>
                                </td>
                                <td>
                                  <v-skeleton-loader
                                    type="text"
                                    class="custom-skeleton table-rows-text"
                                  ></v-skeleton-loader>
                                </td>
                                <td>
                                  <v-skeleton-loader
                                    type="text"
                                    class="custom-skeleton table-rows-text"
                                  ></v-skeleton-loader>
                                </td>
                                <td>
                                  <v-skeleton-loader
                                    type="text"
                                    class="custom-skeleton table-rows-text"
                                  ></v-skeleton-loader>
                                </td>
                              </tr>
                            </template>
                            <tr v-else-if="!pageLoading">
                              <td colspan="4">
                                <p
                                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                                >
                                  <img
                                    :src="$assetURL('media/error/empty.png')"
                                    class="row-not-found-image"
                                  />
                                  Uhh... There are no leave at the moment.
                                </p>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </template>
                    </ListingTable>
                  </v-card-text>
                </v-card>
              </v-col>
              <!--<v-col md="12" class="py-0">
                <v-card flat class="custom-grey-border remove-border-radius mb-4 h-100">
                  <v-card-title class="headline grey lighten-4">
                    <span class="font-weight-700 custom-headline color-custom-blue font-size-16">
                      Leave Reason</span>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <read-more class="custom-read-more font-weight-600 font-size-18 custom-gray-color"
                      more-str="read more" :text="leaveDetail.reason || '<em>No Reason</em>'" link="#"
                      less-str="read less" :max-chars="200">
                    </read-more>
                  </v-card-text>
                </v-card>
              </v-col> -->
            </v-row>
          </v-tab-item>
          <v-tab-item :value="'history'">
            <InternalHistoryDetail
              type="leave"
              :type_id="leaveDetail.id"
            ></InternalHistoryDetail>
          </v-tab-item>
          <v-tab-item :value="'attachment'">
            <div class="service-detail-height">
              <AdditionalDocuments
                :extensive="true"
                :type-id="leaveDetail.id"
                class="mx-3 mb-3"
                type-text="Leave Attachments"
                :type="24"
              />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </perfect-scrollbar>
      <!-- <LeaveDelete :deleteDialog="leaveDeleteDialog" :requestUrl="leaveDeleteRequestUrl"
        v-on:delete:success="leaveDeleteSuccess" v-on:delete:close="leaveDeleteDialog = false"></LeaveDelete> -->

      <Dialog :commonDialog="deleteConfirmDialog" width="100px">
        <template v-slot:title>Confirmation</template>
        <template v-slot:body>
          <v-container fluid class="py-0">
            <v-icon left color="red darken-2">mdi-alert</v-icon>
            <span class="font-weight-medium">
              Are you Sure want to delete the selected leave(s).
            </span>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            class="mx-2 custom-grey-border custom-bold-button white--text"
            color="cyan"
            @click="deleteLeaves"
          >
            Delete
          </v-btn>
          <v-btn
            depressed
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteConfirmDialog = false"
          >
            Close
          </v-btn>
        </template>
      </Dialog>
    </template>
  </DetailTemplate>
</template>
<script>
import moment from "moment-timezone";
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET, PATCH, POST } from "@/core/services/store/request.module";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
// import CustomStatus from "@/view/pages/partials/CustomStatus";
// import FileTemplate from "@/view/pages/partials/FileTemplate";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
// import LeaveDelete from "@/view/pages/partials/Delete-Request-Template.vue";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import Dialog from "@/view/pages/partials/Dialog";
import ValidationMixin from "@/core/plugins/validation-mixin";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "leave-detail",
  title: "Detail Leave",

  data() {
    return {
      rejected_remark: null,
      cancelled_remark: null,
      statusDialog: false,
      deleteConfirmDialog: false,
      leaveBarcode: null,
      statusdata: null,
      engineerLeave: [],
      value1: 15,
      value2: 5,
      value3: 10,
      value4: 30,
      leaveStatusType: "all",
      leaveTab: "leave",
      leave: null,
      duration: null,
      leaveType: "Paid",
      // leaveTypeData: ["Paid", "UnPaid"],
      // leaveDeleteDialog: false,
      add_document_dialog: false,
      moreActions: new Array(),
      attachments: new Array(),
      pageLoading: false,
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "leave",
          disabled: false,
        },
        {
          title: "Attachments",
          icon: "mdi-download",
          key: "attachment",
          disabled: false,
        },
        {
          title: "History",
          icon: "mdi-credit-card",
          key: "history",
          disabled: false,
        },
      ],
      // selectedAll: false,
      selectedRows: [],
      leave_stats: [],
      leaveData: [
        {
          id: 1,
          barcode: "LEV-000003",
          leave_duration: 2,
          leave_type: "Medical",
          // leave_status: "Unpaid",
          // leave_start_date: "26/12/2023",
          // leave_end_date: "26/12/2023",
          leave_start_time: null,
          leave_end_time: null,
          reason: null,
          status: "Pending",
          team_email_id: null,
          attachments: null,
          applied_at: "5 Days Ago",
          action_date: "25/12/2023",
        },
      ],
      leaveDetail: new Object({
        barcode: null,
        engineer: null,
        leave_duration: null,
        leave_type: null,
        leave_start_date: null,
        leave_end_date: null,
        leave_start_time: null,
        leave_end_time: null,
        reason: null,
        status: null,
        remark: null,
        user_designation: null,
        user_email: null,
        user_phone: null,

        team_email_id: null,
        attachments: [],
      }),
    };
  },
  components: {
    DetailTemplate,
    // CustomStatus,
    // LeaveDelete,
    Dialog,
    // FileTemplate,
    InternalHistoryDetail,
    AdditionalDocuments,
    ListingTable,
  },
  methods: {
    goToEngDetail(id) {
      this.$router.push({
        name: "admin.engineer.detail",
        params: { id },
      });
    },
    dropData(leaveId) {

      this.autoRefresh = false;
      this.pageLoading = true;
      let payload = {
        leaves: leaveId,
        status: this.statusdata, // 1: Pending, 2: Approved, 3: Rejected 4: cancelled
        remark:
          this.statusdata == "rejected"
            ? this.rejected_remark
            : this.statusdata == "cancelled"
            ? this.cancelled_remark
            : null,
      };
      this.$store
        .dispatch(PATCH, {
          url: `leave/${leaveId}/${this.statusdata}`,
          data: payload,
        })
        .then(() => {
          this.statusDialog = false;
          this.reject_remark = null;
          this.cancelled_remark = null;
          this.getLeave();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    getProfileImage() {
      if (!this.leaveDetail.profile_logo) {
        return null;
      }
      return this.leaveDetail.profile_logo.file.url;
    },

    // leaveDeleteSuccess() {
    //   this.leaveDeleteDialog = false;
    //   this.goBack();
    // },
    updateMoreAction() {
      // this.leaveBarcode = this.leaveDetail.barcode;
      // const _this = this;
      // switch (action) {
      //   case "edit":
      //     _this.$router.push(
      //       _this.getDefaultRoute("leave.update", {
      //         params: {
      //           id: _this.leave,
      //         },
      //       })
      //     );
      //     // _this.create_leave_dialog = true;
      //     break;
      //   case "delete":
      //     _this.leaveDeleteDialog = true;
      //     break;
      //   case "mark_as_approved":
      //     // _this.updateLeave({ status: 2 });
      //     this.statusdata = "approved";
      //     this.statusDialog = true;
      //     break;
      //   case "mark_as_cancelled":
      //     // _this.updateLeave({ status: 2 });
      //     this.statusdata = "cancelled";
      //     this.statusDialog = true;
      //     break;
      //   case "mark_as_rejected":
      //     // _this.updateLeave({ status: 3 });
      //     this.statusdata = "rejected";
      //     this.statusDialog = true;
      //     break;
      // }
    },
    updateLeave(data) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "leave/" + _this.leave,
          data: data,
        })
        .then(() => {
          _this.getLeave();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    deleteLeaves() {
      const _this = this;
      _this.pageLoading = true;

      _this.$store
        .dispatch(POST, {
          url: "leave/delete",
          data: {
            data: this.selectedRows,
            leave_id: _this.leave
          },
        })
        .then(() => {
            _this.$router.push(
            _this.getDefaultRoute("leave", {
            
            })
          );
          // _this.getLeave();
          // _this.selectedRows = [];
          // _this.deleteConfirmDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getLeave() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "leave/" + _this.leave,
        })
        .then(({ data }) => {
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Leave", route: "leave" },
            { title: "Detail" },
            { title: data.barcode },
          ]);
          _this.leaveDetail = new Object({
            id: data.id,
            barcode: data.barcode,
            engineer: data.engineer,
            leave_duration: data.duration,
            leave_days: data.total_leave_days,
            leave_type: data.category,
            leave_start_date: data.start_date,
            leave_end_date: data.end_date,
            leave_start_time: data.start_time,
            leave_end_time: data.end_time,
            reason: data.reason,
            status: data.status,
            cancelled_by: data.cancelled_by,
            rejected_by: data.rejected_by,
            approved_by: data.approved_by,
            team_email_id: data.email,
            staffde: data.staffde,
            leave_types: data.leave_types,
            user_designation:
              this.lodash.get(data, "staffde.designation.text") ?? null,
            staff_id: this.lodash.get(data, "staffde.id") ?? null,
            eng_barcode: this.lodash.get(data, "staffde.barcode") ?? null,
            user_email: this.lodash.get(data, "staffde.primary_email") ?? null,
            user_phone: this.lodash.get(data, "staffde.primary_phone") ?? null,
            user_display_name:
              this.lodash.get(data, "staffde.display_name") ?? null,
            profile_logo:
              this.lodash.get(data, "staffde.profile_logo.file.url") ?? null,
            remark:
              data.status == 3
                ? data.rejected_remark
                : data.status == 4
                ? data.cancelled_remark
                : null,
            user_data: data.user_data,
            attachments: [],
          });
          _this.leave_stats = data.leave_stats ?? [];
          _this.attachments = data.attachments;
          _this.moreActions = data.more_actions;
          _this.engineerLeave = data.engineer_leave;
        })
        .catch((error) => {
          _this.logError(error);
          _this.goBack();
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    const _this = this;

    _this.leave = _this.lodash.toSafeInteger(_this.$route.params.id);

    if (_this.leave <= 0) {
      _this.goBack();
    }
    _this.getLeave();
  },
  computed: {
    selectedAll: {
      set(param) {
        this.selectedRows = [];
        if (param && this.engineerLeave?.length) {
          for (let i = this.engineerLeave.length - 1; i >= 0; i--) {
            this.selectedRows.push(this.engineerLeave[i].id);
          }
        }
      },
      get() {
        let totalItems = this.engineerLeave?.length;
        return totalItems > 0 ? this.selectedRows?.length === totalItems : [];
      },
    },
    leaveDeleteRequestUrl() {
      return "leave/" + this.leave;
    },
    leaveTitle() {
      return this.leaveDetail.leave_type;
    },
  },
  created() {
    const _this = this;
    _this.leave = _this.$route.params.id;
    if (!_this.leave || _this.leave <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.leaveTab = _this.$route.query.tab;
    }
  },
};
</script>
<style scoped>
span.highlight_batch {
  display: inline-block;
  padding: 4px 15px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  border-radius: 0 0 10px/0px 0 10px;
  position: relative;
  left: -12px;
  top: -12px;
}

.leavetype1 {
  background: #28c76f;
}

.leavetype2 {
  background: #ea3829;
}

.leavetype3 {
  background: #ef7725;
}

.leavetype4 {
  background: #3892f3;
}
</style>
